<p-dialog   class="custom-dialog"  [dismissableMask]="true" [(visible)]="display" [style]="{width: '55vw',  height: '80vh'}" dataKey="id"
      [baseZIndex]="3000" [responsive]="true" [modal]="true" [breakpoints]="{ 
            '2000px': '60vw',
            '1800px': '60vw',
            '1700px': '70vw',
            '1600px': '75vw',
            '1400px': '80vw'
          }">
<ng-template pTemplate="header">
  <div 
    class="custom-header" 
    style="display: flex; align-items: center; justify-content: space-between; width: 100%;"
  >
    <button 
      pButton 
      type="button" 
      icon="pi pi-arrow-left" 
      class="p-button-text" 
      (click)="hide()" 
      style="margin-left: 0;"
    ></button>
    <span 
      class="dialog-title p-dialog-title" 
      style="flex-grow: 1; text-align: center;  "
    >
      {{ title }}
    </span>
  </div>
</ng-template>


    <!-- BODY -->
    <div class="container-xl">
        <div class="ui-grid-row">
            <div class="ui-grid-col-12">
              <!-- <p-messages [(value)]="messages"></p-messages> -->
            </div>
        </div>
        <div class="row">


        <!-- CUSTOMER TAB-VIEW  -->
        <p-tabView *ngIf="display" class="mt-0" class="custom-tab" [activeIndex]="tabActiveIndex"
            > <!-- *ngIf="canViewNotifications"-->
            <!-- NOTIFICATIONS   canViewNotifications -->
            <p-tabPanel header="{{'header.notifications-panel.notifications' | translate | uppercase }}"> 
                <app-notifications-form [(receiverId)]="receiverId" [isDefault]="true" [receiverType]="customerNotificationReceiver" ></app-notifications-form>     
            </p-tabPanel>

            
            <p-tabPanel *ngIf="manageAnalysis" header="{{'header.planner-configuration' | translate | uppercase }}">
              <app-analysis-configuration ></app-analysis-configuration>
            </p-tabPanel>
        </p-tabView>




        <br>
    </div>
    </div>
    <p-confirmDialog i18n-header header="Confirmation" icon="fa fa-question-circle" width="425"></p-confirmDialog>
        <p-footer>
      <div class="d-flex justify-content-center bd-highlight  " style="height: 0px;">
        
      </div>
   </p-footer>
</p-dialog>